export interface ConsentDocumentVersionApiResource {
  id: string;
  version: number;
  title_en: string;
  title_pl: string;
  body_en: string;
  body_pl: string;
  published_at: string;
}

export interface ConsentDocumentVersion {
  id: string;
  version: number;
  titleEn: string;
  titlePl: string;
  bodyEn: string;
  bodyPl: string;
  publishedAt: string;
}

export interface ConsentDocumentApiResource {
  id: string;
  code: string;
  is_required: boolean;
  is_active: boolean;
  sort_order: number;
  current_version: ConsentDocumentVersionApiResource;
}

export interface ConsentDocument {
  id: string;
  code: string;
  isRequired: boolean;
  isActive: boolean;
  sortOrder: number;
  currentVersion: ConsentDocumentVersion;
}

export interface ConsentDocumentDetailApiResource extends ConsentDocumentApiResource {
  versions: ConsentDocumentVersionApiResource[];
}

export interface ConsentDocumentDetail extends ConsentDocument {
  versions: ConsentDocumentVersion[];
}

export interface ConsentDocumentListApiResource {
  items: ConsentDocumentApiResource[];
}

export interface ConsentDocumentWritePayload {
  titleEn: string;
  titlePl: string;
  bodyEn: string;
  bodyPl: string;
  isRequired: boolean;
  sortOrder: number;
}

function mapVersion(resource: ConsentDocumentVersionApiResource): ConsentDocumentVersion {
  return {
    id: resource.id,
    version: resource.version,
    titleEn: resource.title_en,
    titlePl: resource.title_pl,
    bodyEn: resource.body_en,
    bodyPl: resource.body_pl,
    publishedAt: resource.published_at,
  };
}

export function mapApiResourceToConsentDocument(
  resource: ConsentDocumentApiResource
): ConsentDocument {
  return {
    id: resource.id,
    code: resource.code,
    isRequired: resource.is_required,
    isActive: resource.is_active,
    sortOrder: resource.sort_order,
    currentVersion: mapVersion(resource.current_version),
  };
}

export function mapApiResourceToConsentDocumentDetail(
  resource: ConsentDocumentDetailApiResource
): ConsentDocumentDetail {
  return {
    ...mapApiResourceToConsentDocument(resource),
    versions: resource.versions.map(mapVersion),
  };
}

export function mapConsentDocumentPayload(
  payload: ConsentDocumentWritePayload
): Record<string, unknown> {
  return {
    title_en: payload.titleEn,
    title_pl: payload.titlePl,
    body_en: payload.bodyEn,
    body_pl: payload.bodyPl,
    is_required: payload.isRequired,
    sort_order: payload.sortOrder,
  };
}
